var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeadco(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 561.49335,
    height: 81.973335,
    viewBox: "0 0 561.49335 81.973335",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,81.973333)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 V 605.898 H 105.844 V 105.84 H 513.383 V 0 H 0",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2418.07,105.84 c 27.16,0 52.26,5 75.27,15.008 23.02,10 42.98,23.75 59.9,41.25 16.9,17.5 30.08,38.468 39.51,62.922 9.42,24.441 14.14,50.839 14.14,79.179 0,28.34 -4.72,54.59 -14.14,78.762 -9.43,24.168 -22.61,44.855 -39.51,62.086 -16.92,17.215 -36.88,30.695 -59.9,40.422 -23.01,9.711 -48.11,14.586 -75.27,14.586 H 2172.68 V 105.84 Z M 2066.84,0 v 605.898 h 350.86 c 42.78,0 82.23,-7.226 118.35,-21.671 36.11,-14.454 67.22,-34.731 93.34,-60.84 26.11,-26.121 46.53,-57.371 61.26,-93.758 14.72,-36.399 22.08,-76.543 22.08,-120.43 0,-43.898 -7.36,-84.738 -22.08,-122.511 -14.73,-37.793 -35.15,-70.43 -61.26,-97.9302 -26.12,-27.5 -57.23,-49.168 -93.34,-65.0078 C 2499.93,7.92188 2460.48,0 2417.7,0 h -350.86",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3076.1,0 c -42.23,0 -81.26,7.92188 -117.1,23.75 -35.83,15.8398 -66.95,37.5078 -93.34,65.0078 -26.4,27.5002 -46.95,60.1372 -61.67,97.9302 -14.73,37.773 -22.09,78.613 -22.09,122.511 0,44.449 7.36,85.012 22.09,121.68 14.72,36.668 35.27,67.926 61.67,93.758 26.39,25.836 57.51,45.84 93.34,60.008 35.84,14.168 74.87,21.253 117.1,21.253 h 328.37 V 500.055 H 3076.1 c -27.23,0 -52.37,-4.875 -75.42,-14.586 -23.07,-9.727 -42.93,-23.207 -59.59,-40.422 -16.67,-17.231 -29.74,-37.793 -39.17,-61.672 -9.46,-23.898 -14.17,-50.289 -14.17,-79.176 0,-28.34 4.71,-54.738 14.17,-79.179 9.43,-24.454 22.5,-45.422 39.17,-62.922 16.66,-17.5 36.52,-31.25 59.59,-41.25 23.05,-10.008 48.19,-15.008 75.42,-15.008 h 328.37 V 0 H 3076.1",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3914.51,105.84 c 27.78,0 53.34,5 76.68,15.008 23.33,10 43.46,23.75 60.42,41.25 16.94,17.5 30.13,38.468 39.59,62.922 9.44,24.441 14.17,50.839 14.17,79.179 0,28.34 -4.73,54.59 -14.17,78.762 -9.46,24.168 -22.65,44.855 -39.59,62.086 -16.96,17.215 -37.09,30.695 -60.42,40.422 -23.34,9.711 -48.9,14.586 -76.68,14.586 H 3767 c -27.23,0 -52.38,-4.875 -75.42,-14.586 -23.07,-9.727 -42.93,-23.207 -59.59,-40.422 -16.67,-17.231 -29.74,-37.793 -39.17,-61.672 -9.47,-23.898 -14.17,-50.289 -14.17,-79.176 0,-28.34 4.7,-54.738 14.17,-79.179 9.43,-24.454 22.5,-45.422 39.17,-62.922 16.66,-17.5 36.52,-31.25 59.59,-41.25 23.04,-10.008 48.19,-15.008 75.42,-15.008 z M 3767,0 c -42.23,0 -81.26,7.92188 -117.1,23.75 -35.83,15.8398 -66.96,37.5078 -93.34,65.0078 -26.4,27.5002 -46.96,60.1372 -61.67,97.9302 -14.73,37.773 -22.09,78.613 -22.09,122.511 0,44.449 7.36,85.012 22.09,121.68 14.71,36.668 35.27,67.926 61.67,93.758 26.38,25.836 57.51,45.84 93.34,60.008 35.84,14.168 74.87,21.253 117.1,21.253 h 147.51 c 43.88,0 84.03,-7.226 120.43,-21.671 36.38,-14.454 67.63,-34.731 93.76,-60.84 26.11,-26.121 46.38,-57.371 60.84,-93.758 14.44,-36.399 21.67,-76.543 21.67,-120.43 0,-43.898 -7.38,-84.738 -22.09,-122.511 -14.73,-37.793 -35.29,-70.43 -61.67,-97.9302 -26.4,-27.5 -57.65,-49.168 -93.76,-65.0078 C 3997.56,7.92188 3957.85,0 3914.51,0 H 3767",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1456.11,240.262 133.26,225.328 134.2,-225.328 z m 188.26,340.34 c -6.12,10.55 -13.2,18.878 -21.24,25.003 -8.07,6.102 -17.93,9.168 -29.59,9.168 -11.67,0 -21.67,-3.066 -30,-9.168 -8.34,-6.125 -15.57,-14.453 -21.68,-25.003 L 1193.5,0.546875 h 120.84 L 1403.97,152.109 h 371.82 L 1866.06,0.546875 h 127.51 L 1644.37,580.602",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 927.234,348.461 H 591.73 v -88.52 H 927.234 Z M 591.734,106.855 V 0.222656 H 1133.39 V 106.855 H 591.734",
    style: {
      fill: "#252323",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 591.734,605.43 V 498.805 H 1133.39 V 605.43 H 591.734",
    style: {
      fill: "#8bcf24",
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    id: "path24"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeadco);
export default __webpack_public_path__ + "static/media/leadco.64199b188f29ab55defc44b73db133cc.svg";
export { ForwardRef as ReactComponent };